import React, {Component} from 'react';
import 'whatwg-fetch'

import './signup-form.css';

const url = "https://script.google.com/macros/s/AKfycbyzdDh9uXauvfjBSBkTiOOYoX_-uFQzHoUFTC6srw30AkVhlLE/exec";
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class SignupForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isFormPending: false,
      isFormSubmitted: false,
      isFormValid: false,
      isFirstNamePresent : false,
      isLastNamePresent : false,
      isEmailPresent : false,
      isEmailValid : false,
    }

    this.validateAndSubmit = this.validateAndSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
  }

  validateAndSubmit (e){
    e.preventDefault();

    let isInvalid = !this.validateForm();

    if (isInvalid) {
      return;
    }

    this.formSubmit();
  }

  validateForm() {
    let isFirstNameValid = this.validateFirstName();
    let isLastNameValid = this.validateLastName();
    let isEmailValid = this.validateEmail();

    let isFormValid = (isFirstNameValid && isLastNameValid && isEmailValid);

    this.setState({isFormInvalid: !isFormValid});

    return isFormValid;
  }

  generateFormQueryString() {
    let formParams =
      {first_name : this.firstNameRef.value,
       last_name: this.lastNameRef.value,
       email_address: this.emailRef.value};

    let esc = encodeURIComponent;

    var query = Object.keys(formParams)
      .map(k => esc(k) + '=' + esc(formParams[k]))
      .join('&');

    return '?' + query;
  }

  formSubmit() {
    this.setState({isPending: true});
    let queryString = this.generateFormQueryString();

    fetch(url + queryString, {
      method: "GET",
      mode: 'no-cors',
      credentials: 'include'
    })
    .then( function(response) {
      console.log(response);
      this.setState({isFormSubmitted: true, isFormPending: false});
      }.bind(this)
    )
    .catch(function(error) {
      console.log(error);
      alert('Error occured');
    });
  }

  validateFirstName() {
    let isFirstNamePresent = this.firstNameRef.value != '';
    this.setState({isFirstNamePresent : isFirstNamePresent});
    return isFirstNamePresent;
  }

  validateLastName() {
    let isLastNamePresent = this.lastNameRef.value != '';
    this.setState({isLastNamePresent : isLastNamePresent});
    return isLastNamePresent;
  }

  validateEmail() {
    let isEmailPresent = this.emailRef.value != '';
    let isEmailValid = emailRegex.test(this.emailRef.value);
    this.setState({isEmailPresent : isEmailPresent});
    this.setState({isEmailValid : isEmailValid});
    return isEmailPresent && isEmailValid;
  }

  generateErrorMessage(condition, text) {
    let shouldDisplayErrorMessages = this.state.isFormInvalid;
    return (
      <div className="invalid-message-wrapper">
        <div className="invalid-message-signup" style={{display: condition && shouldDisplayErrorMessages ? 'inline-block' : 'none'}}>
          {text}
        </div>
      </div>
    );
  }

  render() {
    let data = this.props.data;
    let {isFormPending, isFormSubmitted, isFormInvalid,
      isFirstNamePresent, isLastNamePresent, isEmailPresent,
      isEmailValid} = this.state;
    console.log(data.submissionMessage);

    if (isFormSubmitted) {
      return (
        <div style={{fontSize : '14'}} className="center form-container">
          {data.submissionMessage}
        </div>
      );
    }

    return (
      <div className="form-container">

        <div className="form-title">
          {data.title}
        </div>

        <div className="form-instruction">
          {data.instruction}
        </div>

        <form style={{marginBottom: 0}} onSubmit={::this.validateAndSubmit}>

          {this.generateErrorMessage(!isFirstNamePresent && !isLastNamePresent, data.missingFirstAndLastNameMsg)}
          {this.generateErrorMessage(!isFirstNamePresent && isLastNamePresent, data.missingFirstNameMsg)}
          {this.generateErrorMessage(isFirstNamePresent && !isLastNamePresent, data.missingLastNameMsg)}

          <div className="center name-container">
            <input
              type="text"
              name="first_name"
              className="signup-form-elem"
              placeholder={data.firstName}
              ref={(input) => this.firstNameRef = input} />

            <input
              type="text"
              name="last_name"
              className="signup-form-elem"
              placeholder={data.lastName}
              ref={(input) => this.lastNameRef = input} />
          </div>

          {this.generateErrorMessage(!isEmailPresent, data.missingEmailMsg)}
          {this.generateErrorMessage(isEmailPresent && !isEmailValid, data.invalidEmailMsg)}

          <div style={{paddingBottom: 10}} className="center" onClick={() => this.emailRef.focus()}>
            <input
              id="email"
              name="email_address"
              type="text"
              className="signup-form-elem"
              placeholder={data.email}
              ref={(input) => this.emailRef = input} />
          </div>

          <div style={{paddingTop: 10}} className="center">
            <button className="signup-submit-button">{data.submit}</button>
          </div>
        </form>
      </div>
    );
  }
}

export default {SignupForm}



// WEBPACK FOOTER //
// ./src/components/Signup/signup-form.js